import { render, staticRenderFns } from "./Simple2ColumnSubSection.vue?vue&type=template&id=4bdafe74&scoped=true"
import script from "./Simple2ColumnSubSection.vue?vue&type=script&lang=js"
export * from "./Simple2ColumnSubSection.vue?vue&type=script&lang=js"
import style0 from "./Simple2ColumnSubSection.vue?vue&type=style&index=0&id=4bdafe74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdafe74",
  null
  
)

export default component.exports